import axios from "axios";
import { url } from "./url";
import { config } from "./token";

const api = axios.create({
  baseURL: `${url}/feedback`,
});

export const sendFeedback = (payload) => api.post(`/send`, payload);

const feedbackApi = {
  sendFeedback,
};

export default feedbackApi;
